import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./LatestAchievements.css";

import Award1 from "../../utils/images/School_Award1.jpg";
import Award2 from "../../utils/images/hero1.PNG";

const achievements = [
  {
    id: 1,
    img: Award1,
    title: "Iqraa Public School Awarded AAA+ Rating for 2024",
    // description:
    //   "Iqraa Public School, Fatehpur Taga, has been recognized as one of India's best schools by Careers360, receiving AAA+ rating in the Day School category.",
  },

  // {
  //   id: 2,
  //   img: Award2,
  //   title: "Students Achieve Academic Excellence",
  //   description:
  //     "Our students continue to excel in academics and co-curricular activities, bringing pride to the school.",
  // },
];

function LatestAchievements() {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % achievements.length);
  };

  const prevSlide = () => {
    setCurrent(
      (prev) => (prev - 1 + achievements.length) % achievements.length,
    );
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const item = achievements[current];

  return (
    <section className="achievement-section">
      <div className="container">
        <h3 className="achievement-heading">Latest Achievements</h3>

        <div className="achievement-wrapper">
          {/* <button className="achievement-arrow left" onClick={prevSlide}>
            <FaChevronLeft />
          </button> */}

          <Card className="achievement-card shadow scale-hover-effect">
            <Card.Img
              variant="top"
              src={item.img}
              className="achievement-image"
            />

            <Card.Body>
              <Card.Title>{item.title}</Card.Title>

              <Card.Text>{item.description}</Card.Text>
            </Card.Body>
          </Card>

          {/* <button className="achievement-arrow right" onClick={nextSlide}>
            <FaChevronRight />
          </button> */}
        </div>

        <div className="achievement-dots">
          {achievements.map((_, index) => (
            <span
              key={index}
              className={`dot ${current === index ? "active" : ""}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default LatestAchievements;
